import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import '../../services/GlobalVariables'
import axios from 'axios'

const API_URL = global.SET_API_URL + 'closing/'

const initialState = {
    closing: [],
    dataForClosing: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: ""
}

export const getFindOpeningByUserID = createAsyncThunk('closing/gcbuID', async (userID, thunkAPI) => {
    try {
        const result = await axios.post(API_URL + 'getFindOpeningByUserID', userID)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const addOpeningByUserID = createAsyncThunk('closing/aobuid', async (dailyOpeningData, thunkAPI) => {
    try {
        const result = await axios.post(API_URL + 'addOpeningByUserID', dailyOpeningData)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const getDataForClosing = createAsyncThunk('closing/gdfc', async (userID, thunkAPI) => {
    try {
        const result = await axios.post(API_URL + 'getDataForClosing', userID)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const addClosingRecord = createAsyncThunk('closing/acr', async (dailyClosingData, thunkAPI) => {
    try {
        const result = await axios.post(API_URL + 'addClosingRecord', dailyClosingData)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const dailyClosingSlice = createSlice({
    name: 'menus',
    initialState,
    reducers: {
        reset: (state) => {
            state.closing = []
            state.dataForClosing = []
            state.isLoading = false
            state.isError = false
            state.isSuccess = false
            state.message = ""
        }

    },
    extraReducers: (builder) => {
        builder
            .addCase(getFindOpeningByUserID.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getFindOpeningByUserID.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.closing = action.payload
            })
            .addCase(getFindOpeningByUserID.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(getDataForClosing.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getDataForClosing.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.dataForClosing = action.payload
            })
            .addCase(getDataForClosing.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
    }
})

export const { reset } = dailyClosingSlice.actions

export default dailyClosingSlice.reducer